export const angularModule = "soy-cliente";
export const log = [];
export const flags = [];
export const servicios = {
  app: "https://clientes-qa.gnp.com.mx/soy-cliente",
  dominio: "gc-qa.gnp.com.mx",
  hostBackend: 'https://gke-soycliente-qa.gnp.com.mx/esd-soy-cliente',
  corporativo: 'https://dev.gnp.com.mx/',
  dominioReingenieria: "https://soycliente-qa.gnp.com.mx/portalsoycliente/",
  validarEmail:
    "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/validarCorreo",
  validarPass:
    "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/iniciarSesion",
  authLtpa: "https://cuentas-qa.gnp.com.mx/auth/ltpa",
  encripta:
    "https://us-central1-gnp-soycliente.cloudfunctions.net/encripta/encriptagnp",
  accesobeta:
    "https://us-central1-gnp-soycliente.cloudfunctions.net/beta/acceso",
  detalle:
    "https://us-central1-gnp-reembolsosgmm-qa.cloudfunctions.net/SIN_CF_identificarPoliza",
  user: {
    accion: "https://us-central1-gnp-soycliente.cloudfunctions.net/userlog/ul",
  },
  login: {
    bienvenido:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/bienvenido",
    nombre:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/nombreCodigo",
    obtenerPreguntas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/obtenerPreguntas",
    validarPreguntas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/validarPreguntas",
    obtenerJwt:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/obtenerJwt",
    actualizaContrato:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/actualizaContrato",
    cerrarsesion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/cerrarSesion",
    portalAutoservicioLogin:
      "https://autoservicio-pagos-autos-qa.gnp.com.mx/login",
    desbloqueoMedios:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/inactividadUsuarios/desbloqueoMedios",
    suspenderMedios:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/inactividadUsuarios/suspenderMedios",
  },
  polizas: {
    listado:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/polizas/listado",
    vidaCapitaliza:
      "https://eotqa.gnp.com.mx/wps/myportal/clientes/gnp/iniciovida?CODLOGIN=LGN001",
    vidaInversion:
      "https://eotqa.gnp.com.mx/wps/myportal/vidainversion/Vida-Inversion/",
    pagoTarjeta:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/recibos/pagar",
    pagoTarjetaCapitaliza:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/recibos/pagarCapitaliza",
    comprobantePago:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/recibos/comprobantePago",
    solicitud:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/polizas/solicitud",
    tipoCambio:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/recibos/tipoCambio",
  },
  pagoPorKilometro: {
    guardarKM:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/guardarKM/guardar",
    consultar:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/consultaKM/consulta",
    alta: "https://us-central1-gnp-soycliente.cloudfunctions.net/altaKm/alta",
    consultarAutorizador:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/consultaKM/consultaAutorizador",
    actualizarEstatusKm:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/guardarKM/actualizaEstatus",
    actualizarNuevoKm:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/guardarKM/actualizaEstatusNuevo",
    restriccionDBK:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/consultaKM/restriccionDBK",
    consultarCorreo:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/consultaKM/consultaCorreo",
  },
  olvideContrasena: {
    consultarUsuario:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/consultarCliente",
    validarUsuario:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/validarCliente",
    actualizarDatos:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/actualizarDatos",
    aceptoContrato:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/aceptarContrato",
    aceptoConfidencialidad:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/aceptarConfidencialidad",
    enviarCorreo:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/mandaCorreo",
    actualizarPassword:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/resetPassword",
    olvidePassword:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/olvidePassword",
    validarNodo:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/validarNodo",
    restablecerPass:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/sesion/olvidePassword",
  },
  miPerfil: {
    obtenerMedios:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/obtenerMediosContacto",
    actualizarMedios:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/actualizarDatos",
    actualizarContrasena:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/actualizarContrasena",
    actualizarPreguntas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/actualizarPreguntas",
    obtenerPreguntas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/obtenerPreguntas",
    validarPreguntas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/validarPreguntas",
    cancelarCuenta:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/perfil/cancelarCuenta",
  },
  otp: {
    validarOtpBan:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/otp/validar-ban",
    obtenerOtpBan:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/otp/generar-ban",
    obtenerOtp:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/otp/generar",
    validarOtp:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/otp/validar",
    reenviarOtp:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/otp/reenviar",
  },
  registro: {
    obtenerurlregistro:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/obtenerhash",
    datosPersonales:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosPersonales",
    datosAsistidos:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosAsistidos",
    datosSeguridad:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosSeguridad",
    datosContratos:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosContratos",
    datosInconvenientes:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosInconvenientes",
    datosCancelacion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosCancelacion",
    datosBorradoUsuarios:  
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/datosBorradoUsuarios",
    obtenerNombreMedios:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/obtenerNombreMedios",
    consultaconcluirregistro:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/consultaConcluirRegistro",
    consultaconcluirregistropoliza:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/consultaConcluirRegistroPoliza",
    consultaregistro:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/registro/consultaRegistro",
    validarOtpBanRegistro:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/otp/validar-ban-otp",
    registroBitacora: "https://gke-soycliente.gnp.com.mx/soycliente/registroClientes",
  },
  utilerias: {
    identificaPoliza:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/identificaPoliza",
    identificaPolizaAuto:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/identificaPolizaAuto",
    identificaPolizaHija:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/identificaPolizaHija",
    identificaCertificado:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/identificaCertificado",
    identificaExistencia:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/identificaExistencia",
    identificaPolizaGrl:  
      "https://us-central1-gnp-soycliente.cloudfunctions.net/asistido/detallePoliza",
    identificaPolizaGrlAzul:"https://us-central1-gnp-soycliente.cloudfunctions.net/asistido/detallePolizaAzul",
    actualizaPersona:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/actualizaPersona",
    detallePoliza:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/detallePoliza",
    clientesMorales:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/clientesMorales",
    validadorMediosContacto: "https://api-qa.oscp.gnp.com.mx/medios-contacto",
    apiKeyMC: "l7xx4065fddfd8044ef6aabbfd28ba8c5858",
    datosUsuarioIdParticipante:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/datosUsuario",
    videos: "https://clientes-uat.gnp.com.mx/servicios-soy-cliente-gnp",
    seguimientoJuridico : "https://seguimiento-juridico-uat.gnp.com.mx/ssal-asegurado-front/",
    tokenRestablecer: "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/actualizaNodo",
    actualizaNodoRestablecer: "https://us-central1-gnp-soycliente.cloudfunctions.net/utilerias/obtenerToken"
  },
  accesoFamiliar: {
    agregarFamiliar:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/agregarFamiliar",
    editarFamiliar:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/editarFamiliar",
    eliminarFamiliar:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/eliminarFamiliar",
    reenviaInvitacion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/reenviaInvitacion",
    validarInvitacion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/validarInvitacion",
    validaUsuario:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/validaUsuario",
    registroInvitacion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/registroInvitacion",
    loginInvitacion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/accesoFamiliar/loginInvitacion",
  },
  facturas: {
    listadoFacturas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/facturas/listado",
    descargaFactura:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/facturas/descarga",
  },
  retenciones: {
    listadoRetenciones:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/retenciones/listado",
    descargaRetencion:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/retenciones/descarga",
  },
  finiquitos: {
    listadoFiniquitos:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenerFiniquitos",
    descargaFiniquito:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/descargarFiniquito",
  },
  descargas: {
    condicionesgenerales:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenercondicionesgenerales",
    poliza:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenerpoliza",
    recibo:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenerrecibo",
    certificado:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenercertificado",
    certificadoazul:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/descargacertificadoazul",
    tarjetas:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/tarjetas/generar",
    generales:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenergenerales",
    rco: "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenerrco",
    edocuenta:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/edocuenta/descarga",
    certificadoECO:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenerCertificadoEco",
    polizarcusa:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/polizarcusa",
    obtenerIdDocumento:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/obtenerIdDocumento",
    orquestadorDocumentos:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/documentos/orquestadorDocumentos",
  },
  recibos: {
    consultar:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/recibos/listado",
  },
  edocuenta: {
    consultar:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/edocuenta/listado",
  },
  siniestrosReparacion: {
    listaSiniestros:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/siniestros/listaSReparacion",
    consultaSiniestro:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/siniestros/obtenerSReparacion",
  },
  siniestrosReembolsos: {
    listaSiniestros:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/siniestros/listaSReembolso",
    portalSiniestros: "https://siniestrosgmm-qa.gnp.com.mx/",
  },
  directorio: {
    endPoint: "https://ddb-dot-gnp-soycliente.appspot.com",
    endPointPlanNP:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/directorios/getHospitales",
    apikeyMaps: "",
  },
  formatos: {
    endPoint: "https://siniestrosgmm-formatosdigitales-qa.gnp.com.mx",
    listaBlanca: "https://estrategiaservicios-qa.gnp.com.mx/msv-formatosdigitales/configuracion/lista-blanca/PDC"
  },
  planDentalia: {
    sumaDentalia:
      "https://us-central1-gnp-dentalia-qa.cloudfunctions.net/polizasuas",
    dentaliaBeneficio:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/serviciosDentalia/beneficiosDentalia",
    tratamientoDentalia:
      "https://us-central1-gnp-dentalia-qa.cloudfunctions.net/tratamientosPacientesDentalia",
    permisoAsistenciaDentalG:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/serviciosDentalia/productosGMMconDentalia",
  },
  beneficiosGnp: {
    listaBeneficiosGnp:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/consultaKM/getBeneficiosCliente",
  },
  tarjetasFrame: {
    endPoint: "https://soycliente-qa.gnp.com.mx/tarjetasgmm/tarjetasgmm/tarjeta-digital/",
    origen: "origen",
    numeroCliente: "clienteUnico",
  },
  directorioFrame: {
    endPoint: "https://soycliente-qa.gnp.com.mx/directorios/?",
    origen: "origen",
    numeroCliente: "clienteUnico",
  },
  multicanal: {
    endPoint: "https://app-dot-gnp-siniestrosdanos-qa.uc.r.appspot.com/",
  },
  avayaOceana: {
    avayaAuraWebGateway: "https://webcall.gnp.com.mx/",
    consultarToken:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/aConnectProxy/token",
    contextStorePOST:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/aConnectProxy/context-store",
    contextStorePUT:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/aConnectProxy/update-context-store",
    catalogoVDN:
      "https://us-central1-gnp-soycliente.cloudfunctions.net/aConnectProxy/get-vdn",
  },
  seguimientoSiniestro: {
    historicoSiniestros:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/poliza/historico/siniestros",
    consultaSiniestroPorPoliza:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/poliza",
    detalleValuacion:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/valuacion/detalle/codSiniestro",
    detalleReparacion:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/reparacion/detalle/codSiniestro",
    detallePagos:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/pagos-parciales/detalle/codSiniestro",
    detalleRobos:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/robo/codSiniestro",
    detallePT:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento/perdidasTotales/detalle/codSiniestro",
    detalleSiniestro:
      "https://api-gc-qa.service.gnp.com.mx/apiseguimientosiniestrosautos/sinau/api/seguimiento",
  },
  misTramites: {
    autos: {
      portalAutoservicioPag:
        "https://gnp-autoserviciosolpag-qa.appspot.com/login",
    },
  },
  iframeGNPURL: {
    centroAtencionGNP: "https://aclaracionesqr-siniestros.gnp.com.mx/",
    directorio: "https://www.gnp.com.mx/soy-cliente#!/directorio",
    accesoFamiliar: "https://www.gnp.com.mx/soy-cliente#!/acceso-familiar",
  },
  pagoDeducibleAutos: {
    urlBaseCF: "https://us-central1-gnp-soycliente.cloudfunctions.net",
    guiaPago:
      "https://storage.googleapis.com/gnp-soycliente.appspot.com/PagoDeducibleAuto/Gu%C3%ADa%20Pago%20deducible%20v2.pdf",
    urlBaseStorage: "https://storage.googleapis.com/gnp-soycliente.appspot.com",
  },
  gobNotFrame: {
    endPoint: "https://gobiernonotificaciones.gnp.com.mx/config-soy-cliente",
  },
  parentesco: {
    cloud:
      "https://us-central1-gnp-reembolsosgmm-qa.cloudfunctions.net/GMM_CF_catalogoTipoParentesco",
  },
};

export const firebaseCfg = {
  apiKey: "AIzaSyARyZZAXT1Wtmd-iZcbfi96juS3JkK73AU",
  authDomain: "gnp-soycliente.firebaseapp.com",
  databaseURL: "https://gnp-soycliente.firebaseio.com",
  projectId: "gnp-soycliente",
  storageBucket: "gnp-soycliente.appspot.com",
  messagingSenderId: "816832734934",
};

export const preguntas = [
  { p: "¿Cuál es el apodo de tu mejor amigo?", i: 1 },
  { p: "¿Cuál fue el nombre de tu primer mascota?", i: 2 },
  { p: "¿Cuál es el nombre de tu escuela primaria?", i: 3 },
  { p: "¿De qué marca fue tu primer auto?", i: 4 },
  { p: "¿Cuál es tu deporte favorito?", i: 5 },
  { p: "¿Cuál es tu país favorito?", i: 6 },
  { p: "¿Cuál es el nombre de tu primer novio (a)?", i: 7 },
  { p: "¿Cuál es tu canción favorita?", i: 8 },
  { p: "¿Cuál es el nombre de tu comida favorita?", i: 9 },
  { p: "¿Cuál fue tu primer viaje al extranjero?", i: 10 },
];
export const preguntas1 = [
  { p: "¿Cuál es el apodo de tu mejor amigo?", i: 1 },
  { p: "¿Cuál fue el nombre de tu primer mascota?", i: 2 },
  { p: "¿Cuál es el nombre de tu escuela primaria?", i: 3 },
  { p: "¿De qué marca fue tu primer auto?", i: 4 },
  { p: "¿Cuál es tu deporte favorito?", i: 5 },
];
export const preguntas2 = [
  { p: "¿Cuál es tu país favorito?", i: 6 },
  { p: "¿Cuál es el nombre de tu primer novio (a)?", i: 7 },
  { p: "¿Cuál es tu canción favorita?", i: 8 },
  { p: "¿Cuál es el nombre de tu comida favorita?", i: 9 },
  { p: "¿Cuál fue tu primer viaje al extranjero?", i: 10 },
];

export const areas = [
  { area: "Arquitectura/Construcción", id: 1 },
  { area: "Autos", id: 2 },
  { area: "Cine", id: 3 },
  { area: "Cocina, Alimentos", id: 4 },
  { area: "Coleccionista", id: 5 },
  { area: "Cultura ", id: 6 },
  { area: "Deportes", id: 7 },
  { area: "Economía, Contabilidad y Finanzas", id: 8 },
  { area: "Educación Académica", id: 9 },
  { area: "Entretenimiento", id: 10 },
  { area: "Hogar", id: 11 },
  { area: "Jurídico ", id: 12 },
  { area: "Lectura ", id: 13 },
  { area: "Manualidades", id: 14 },
  { area: "Marketing ", id: 15 },
  { area: "Medicina y Salud", id: 16 },
  { area: "Moda", id: 17 },
  { area: "Música ", id: 18 },
  { area: "Negocios", id: 19 },
  { area: "Opera", id: 20 },
  { area: "Seguros y Pensiones", id: 21 },
  { area: "Teatro", id: 22 },
  { area: "Tecnología", id: 23 },
  { area: "Viajes", id: 24 },
];

export const multicanalMascota = {
  endPoint: "https://multicanal-app-dot-gnp-siniestrosdanos-qa.uc.r.appspot.com/",
  imagenes: "https://mascotas-backend-qa.gnp.com.mx/"
};
export const URL_ENDPOINT_CODFILIACION =
  "https://crm-consultapersona-qa.oscp.gnp.com.mx/consulta-persona/consulta-persona-id-participante";


// WEBPACK FOOTER //
// ./src/properties.js